module.exports = __webpack_public_path__ + "img/bibb-logo.476c29f3.jpg";